"use strict";
/*
 * Created on 5. 10. 2018
 *
 * Copyright (c) 2018 Etnetera, a.s. All rights reserved.
 * Intended for internal use only.
 * http://www.etnetera.cz
 */

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var StructPropBuilder_1 = require("../../core/model/data-dictionary/StructPropBuilder");

var DomainObject_1 = require("../../core/model/DomainObject");

var ValidationResult_1 = require("../../core/model/errors/ValidationResult");
/**
 * Price change index.
 * @author Radek Beran
 */


var PriceChangeIndex =
/*#__PURE__*/
function (_DomainObject_1$Domai) {
  _inherits(PriceChangeIndex, _DomainObject_1$Domai);

  /**
   * @param value value of price change
   * @param aboveThreshold true if value is above threshold set in global settings
   */
  function PriceChangeIndex(value, aboveThreshold) {
    var _this;

    var validationResult = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : ValidationResult_1.ValidationResult.EMPTY;

    _classCallCheck(this, PriceChangeIndex);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(PriceChangeIndex).call(this));
    _this.value = value;
    _this.aboveThreshold = aboveThreshold;
    _this.validationResult = validationResult;
    return _this;
  }
  /**
   * Converter from data-dictionary representation to price change index.
   */


  _createClass(PriceChangeIndex, [{
    key: "withValidationResult",
    value: function withValidationResult(validationResult) {
      return this.copy('validationResult', validationResult);
    }
  }, {
    key: "withMessage",
    value: function withMessage(message) {
      return this.copy('validationResult', this.validationResult.addObjectIfNotPresent(message));
    }
  }], [{
    key: "fromDataDict",
    value: function fromDataDict(mat) {
      return new PriceChangeIndex(mat.value, mat.aboveThreshold, mat.validationResult);
    }
  }]);

  return PriceChangeIndex;
}(DomainObject_1.DomainObject);

exports.PriceChangeIndex = PriceChangeIndex;

PriceChangeIndex.schema = function () {
  var builder = new StructPropBuilder_1.StructPropBuilder(PriceChangeIndex.name);
  return {
    value: builder.bigNum('value'),
    aboveThreshold: builder.opt(builder.bool('aboveThreshold')),
    validationResult: builder.obj('validationResult', ValidationResult_1.ValidationResult.schema, function (mat) {
      return new ValidationResult_1.ValidationResult(mat.resultObjects);
    })
  };
}();